import { h, Component } from 'preact';

import Button from 'components/button/button';

export default class GoToMediaButton extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}
	
	handleClick() {
		const { movie } = this.props;
		const movieId = movie?.base_movie_id || movie?.id;
		if (movieId) window.location.hash = `movies/${movieId}/media`;
	}

	render() {
		const { movie, label, ...rest } = this.props;
		return (
			<Button
				disabled={!movie?.id}
				iconAlt="chevron-right"
				onClick={this.handleClick}
				style={{ display: 'flex', width: 'fit-content' }}
				{...rest}
			>
				{label || 'Go to media'}
			</Button>
		);
	}
}

